var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoubleChevron = function SvgDoubleChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.85 6.65a.5.5 0 1 0-.7.7L11.79 12a1 1 0 0 0 1.42 0l4.64-4.65a.5.5 0 0 0-.7-.7l-4.65 4.64zm0 5a.5.5 0 0 0-.7.7L11.79 17a1 1 0 0 0 1.42 0l4.64-4.65a.5.5 0 0 0-.7-.7l-4.65 4.64z",
    clipRule: "evenodd"
  })));
};
export { SvgDoubleChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuODUgNi42NWEuNS41IDAgMSAwLS43LjdMMTEuNzkgMTJhMSAxIDAgMCAwIDEuNDIgMGw0LjY0LTQuNjVhLjUuNSAwIDAgMC0uNy0uN2wtNC42NSA0LjY0LTQuNjUtNC42NFptMCA1YS41LjUgMCAwIDAtLjcuN0wxMS43OSAxN2ExIDEgMCAwIDAgMS40MiAwbDQuNjQtNC42NWEuNS41IDAgMCAwLS43LS43bC00LjY1IDQuNjQtNC42NS00LjY0WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";